import React, { useEffect } from "react";
import { attachmentFilestack } from "../attachments/actions";
import AssignmentForm from "../assignments/form/Form";
var AssignmentTemplateNew = function AssignmentTemplateNew(_ref) {
  var assignmentTemplate = _ref.assignmentTemplate;
  useEffect(function () {
    attachmentFilestack();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(AssignmentForm, {
    assignment: assignmentTemplate,
    content: "assignment_template"
  });
};
export default AssignmentTemplateNew;